import React from 'react';
import styled from 'styled-components';

const Element = styled.div`
  font-size: 15px;
  color: #2c3e50;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

const Subtitle = ({ label }) => <Element>{label}</Element>;

export default Subtitle;
